// extracted by mini-css-extract-plugin
export default {"container":"Exercise_container__5jlBx","title":"Exercise_title__src6c","exerciseList":"Exercise_exerciseList__TtuC6","exercise":"Exercise_exercise__DDK2O"};